import { NotFoundRoutingModule } from './not-found-routing.module';
import { NgModule } from '@angular/core';
import { NvButtonModule } from 'projects/shared/nvps-libraries/design/nv-button/nv-button.module';
import { NvLogoModule } from 'Src/nvps-libraries/design/nv-logo/nv-logo.module';
import { GenericFooterModule } from '../generic-footer/generic-footer.module';
import { NotFoundSvgComponent } from './not-found-svg/not-found-svg.component';
import { NotFoundComponent } from './not-found.component';

@NgModule({
  imports: [NvLogoModule, NvButtonModule, GenericFooterModule, NotFoundRoutingModule],
  declarations: [NotFoundComponent, NotFoundSvgComponent],
})
export class NotFoundModule {}
